import Delta from 'quill-delta';

import { Paragraph } from '../../common/Text';
import { renderDelta } from './quill/renderDelta';

export function isQuillDeltaEmpty(value?: Delta) {
	if (!value) {
		return true;
	}

	return (
		value.ops
			.map((op) => op.insert ?? '')
			.join('')
			.trim().length === 0
	);
}

export function quillDeltaToPlainText(value?: Delta) {
	if (!value) {
		return '';
	}

	return value.ops
		.map((op) => (typeof op.insert === 'string' ? op.insert : ''))
		.join('')
		.replace(/\s+/g, ' ')
		.trim();
}

export function QuillText(props: { value?: Delta; placeholder?: string }) {
	if (!props.value || isQuillDeltaEmpty(props.value)) {
		if (props.placeholder) {
			return <Paragraph>{props.placeholder}</Paragraph>;
		}
		return null;
	}

	return (
		<div className="ql-boxed ql-readonly ql-inline">
			<div className="ql-wrapper">
				<div className="ql-editor">{renderDelta(props.value)}</div>
			</div>
		</div>
	);
}

QuillText.isEmpty = isQuillDeltaEmpty;
QuillText.toPlainText = quillDeltaToPlainText;
